import styled from "styled-components";

export const GlobalPassionDrawerCountersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 0px;
  flex-wrap: wrap;

  & > :not(:last-child) {
    margin-right: 20px;
  }
`;

export const GlobalPassionDrawerCounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  & > :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const GlobalPassionDrawerCounterIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  & > :not(:last-child) {
    margin-right: 8px;
  }
`;

export const GlobalPassionDrawerCounter = styled.span`
  font-weight: 300;
  font-size: 38px;
  line-height: 42px;
  text-align: center;
  color: #171C33;
`

export const GlobalPassionDrawerCounterText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(23, 28, 51, 0.5);
`;

export const GlobalPassionDrawerHighlightText = styled.h4`
  font-weight: 300;
  font-size: 24px;
  line-height: 31px;

  & > .people {
    color: #FFC229;
  }

  & > .company {
    color: #5478A1;
  }
`;

export const GlobalPassionDrawerHighlightTextContainer = styled.div`
  & :not(:last-child) {
    margin-bottom: 10px;
  }
`;